import {SysRole as Role} from './sys.role';

export class SysAccount {
    constructor(){
        this.IsLogin = false;
        this.IsAdmin = false;
       this.Departments = new Array<any>();
       this.img = "";
       this.AppVersion="0.0.0.0";
       this.IsUpdate=true;
    }
    /**
     * 是否登录成功
     */
    IsLogin: boolean;
    /**
     * 登录者ID
     */
    Id: string;
    /**
     * 登录者姓名
     */
    DisplayName: string;
    /**
     * 是否首页
     */
    HomeUrl: string;
    /**
     * 员工编号
     */
    CustomerID:string;
    /**
     * 是否管理员
     */
    IsAdmin: boolean;
    /**
     * 最后一次登录时间
     */
    LastPageUpdateDate: string;
    Limit: any;
    /**
     * 登录名
     */
    LoginName: string;
    Departments: Array<any>;
    RoleIds: Array<any>;
    Roles: Array<Role>;
    /**
     * 获取图像信息
     */
    img: string;
    /**
     * 创建时间
     */
    CreateTime: string;
    /**
     * 获取手机唯一识别码
     */
    uuid: string;
    /**
     * 手机号码
     */
    phone: string;
        /**
     * 用户头像
     */
    Pic: string;
    /**
     * APP版本号 default：0.0.0.0
     */
    AppVersion?:string;
    /**
     * 是否立即更新默认true
     */
    IsUpdate:boolean;
     /**
     * 企业微信id
     */
    QYWXId?: string;
    /**
     * 企业类型
     */
    QYWXIdType?:string;
    /**
     * 企业微信code
     */
    QYWXQRCode?:string;
}